// extracted by mini-css-extract-plugin
export default {"overlay":"LH-z","bodyOpen":"MH-z","content":"NH-z","header":"OH-z","close":"PH-z","closeNoHeading":"QH-z"};